import { Box, Chip, Typography } from "@mui/material"
import { CheckCircleFilledOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"

import { ProductStatusCell } from "@/components/table"
import type { Product, ProductVersionStatus } from "@/graphql/codegen/graphql"
import { getVersionStatusColor } from "@/screens/Products/utils/productVersion"
import { formatDate } from "@/utils/date"

interface ProductsAddedProps {
  products: Product[]
}

export const ProductsAdded = ({ products }: ProductsAddedProps): ReactElement => {
  return (
    <Box className='space-y-4'>
      <Box className='flex items-center'>
        <Typography variant='body1' fontWeight={700} className='text-gray-700'>
          Products Added
        </Typography>
        <Box className='ml-2 flex items-center text-green-500'>
          <CheckCircleFilledOutlined className='text-tertiary-green-500' />
        </Box>
      </Box>
      <Box className='max-h-64 w-full overflow-y-auto rounded-md border border-gray-100 text-sm text-gray-700'>
        {products.map((product) => (
          <Box key={product.productId} className='grid w-full' style={{ gridTemplateColumns: "30% 70%" }}>
            <Box className='flex flex-col border border-gray-100 px-4 py-2'>
              <ProductStatusCell product={product} />
              <Chip
                avatar={
                  <Box
                    className={`flex w-fit items-center justify-center rounded p-1 ${getVersionStatusColor(product?.versionStatus as ProductVersionStatus)}`}
                  >
                    v{product.versionNumber}
                  </Box>
                }
                label={<span className='px-1'>{formatDate(product?.versionReleaseDate ?? "")}</span>}
                variant='filled'
                size='small'
                className='mt-1 rounded bg-gray-300 text-gray-900'
              />
            </Box>

            <Box className='flex items-center border border-gray-100 px-4 py-2'>
              {product.vendorDescription || product.companyProductDescription}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
